export const VerificationMethod = {
    EMAIL: "EMAIL",
    PHONE: "PHONE",
} as const;

export type Location = {
    id: number;
    name: string;
    street?: string | null;
    houseNumber?: string | null;
    postalCode?: string | null;
    city?: string | null;
};

export type CompanyInfo = {
    slug: string;
    name: string;
    smsEnabled: boolean;
    /** Toont het WhatsApp-opt-in-vinkje in de laatste stap. Ontbreekt bij oudere/gecachte
     * responses, dan valt de widget terug op "uit". */
    whatsappEnabled?: boolean;
    brandColor: string | null;
    widgetPosition: "bottom-right" | "bottom-left" | "top-right" | "top-left" | null;
    widgetShape: "rounded" | "square" | null;
    widgetButtonText: string | null;
    /** Widget-huisstijl (vervolg) — achtergrondkleur, curated lettertype-preset (zie
     * FONT_PRESETS in bookit-widget.tsx) en popup/inline-modus. Ontbreken bij oudere/
     * gecachte responses, dan valt de widget terug op zijn eigen defaults. */
    widgetBackgroundColor?: string | null;
    widgetFont?: string | null;
    widgetMode?: "popup" | "inline" | null;
    /** PRO-feature — alleen dan toont de widget de NL/EN-taalknop. Ontbreekt bij oudere/
     * gecachte responses, dan valt de widget terug op "uit" (alleen NL). */
    multiLangEnabled?: boolean;
    /** Optionele aanbetaling (Mollie) — als depositEnabled aan staat, toont de widget het
     * bedrag in de samenvatting en stuurt de klant na het boeken door naar Mollie's
     * checkout (zie ReservationResponse.depositCheckoutUrl). Ontbreekt bij oudere/gecachte
     * responses, dan valt de widget terug op "uit". */
    depositEnabled?: boolean;
    depositAmountCents?: number;
    /** false = proefperiode/abonnement van het bedrijf verlopen, online boeken kan niet.
     * Ontbreekt bij oudere/gecachte responses, dan gaat de widget uit van "open". */
    bookingsEnabled?: boolean;
    /** Toont "Zet me op de wachtlijst" als een dag vol is. Ontbreekt bij oudere responses → uit. */
    waitlistEnabled?: boolean;
    /** Ontbreekt bij oudere/gecachte responses — de widget behandelt dat als "één
     * vestiging" en slaat de locatiekeuze-stap over. */
    locations?: Location[];
};

export type Service = {
    id: number;
    name: string;
    /** Optionele Engelse naam die de klant zelf instelt (Diensten-scherm in het
     * dashboard). Null/leeg = widget toont `name`, ook in EN-modus. */
    nameEn?: string | null;
    durationMinutes: number;
    priceCents?: number;
    /** Voor het groeperen van diensten in tabs/pillen — null = geen categorie, dienst
     * verschijnt dan onder een generieke "Overig"-groep. */
    categoryId?: number | null;
    categoryName?: string | null;
    /** Hoeveel klanten er tegelijk op hetzelfde tijdstip kunnen boeken — 1 (default) is
     * een normale 1-op-1 afspraak, hoger is een groepsles/cursus. */
    capacity?: number;
};

export type Staff = {
    id: number;
    name: string;
};

export type TimeSlot = {
    start: string; // ISO string
    end: string;   // ISO string
    /** Alleen aanwezig bij een gekozen medewerker — capaciteit/bezetting van dit exacte
     * tijdstip. >1 capaciteit = groepsles ("6 van 15 plekken"). */
    capacity?: number;
    booked?: number;
};

export type ReservationRequest = {
    serviceId: number;
    staffId: number;
    startTime: string;
    customerName: string;
    customerEmail: string;
    customerPhone:string,
    notes: string;
    verificationMethod: "EMAIL" | "PHONE";
    // Alleen gevuld als de widget op de eigen /boek/{bedrijf}-pagina (boekkoek.nl) draait —
    // zie captchaToken prop in Widget/BookFlow. Ontbreekt bij een embed op een klant-site.
    captchaToken?: string;
    // Alleen meegestuurd als een kortingscode uit de URL (?discount=) vooraf succesvol
    // gevalideerd is — zie previewDiscountCode/BookFlow.
    discountCode?: string;
    // Toestemming voor een herinnering via WhatsApp; alleen zinvol met customerPhone erbij.
    whatsappOptIn?: boolean;
};


export type ReservationResponse = {
    id: number;
    start: string;
    end: string;
    status?: string;
    /** Alleen gevuld als dit bedrijf een aanbetaling vereist — de widget stuurt de klant
     * hier dan naartoe i.p.v. direct de "gelukt"-melding te tonen. */
    depositCheckoutUrl?: string | null;
    /** Gesnapshotte prijs (incl. eventuele korting) op het moment van boeken. */
    priceCents?: number | null;
};

export type DiscountCodePreview = {
    discountPercent: number;
};

export type ConfirmReservationResponse = {
    reservationId: number;
    status: string;
    startTime: string;
    endTime: string;
    companyId: number;
    staffId: number;
    serviceId: number;
};

export  type changeReservationRequest={
    token : string;
    newStartTime:string;
    staffId:number;
    serviceId:number;
}

export type changeReservationResponse={
    reservationId:number;
    status:string;
    startTime:string;
    endTime:string;
    staffId: number;
    serviceId: number;
}

export type cancelReservationRequest={
    token:string;
}

export type cancelReservationResponse={
    reservationId: number;
    status:string,
    startTime:string;
    endTime:string;
}

/** Zie BookingController.reservationStatus / ReservationStatusResponse.java. */
export type ReservationStatusResponse = {
    id: number;
    status: string;
    depositStatus: "NONE" | "PENDING" | "PAID" | "REFUNDED" | "FAILED";
};

